import { withStyles } from '@mui/styles';

import { AdminUserForm } from './AdminUserForm';
import muiStyles from './styles';

export default withStyles(muiStyles)(AdminUserForm as any);